import React, { useState } from "react";
import whatsApp from "../assets/images/whatsapp.png";
import Navbar1 from "./Navbar1";
import Footer from "./Footer";

const Layout = ({ children }: any) => {
  const [showOptions, setShowOptions] = useState(false);

  const handleWhatsAppClick = (phone: string, message: string = "") => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappWebUrl = `https://web.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
    const whatsappAppUrl = `whatsapp://send?phone=${phone}&text=${encodedMessage}`;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const whatsappUrl = isMobile ? whatsappAppUrl : whatsappWebUrl;
    window.open(whatsappUrl, "_blank");
  };

  const handleCallClick = (phone: string) => {
    window.location.href = `tel:${phone}`;
  };

  return (
    <div className="position-relative overflow-hidden">
      <main>{children}</main>
      <Footer />
      <div className="position-fixed z-3 m-4 bottom-0 left">
        <img
          src={whatsApp}
          style={{ width: "50px", cursor: "pointer" }}
          alt="WhatsApp or Call"
          onClick={() => setShowOptions(!showOptions)}
        />
        {showOptions && (
          <div className="bg-white shadow-lg p-3 rounded mt-2">
            <button
              className="block w-full text-left text-green-600 p-2"
              onClick={() => handleWhatsAppClick("+966510731221", "مرحبا بك")}
            >
              WhatsApp
            </button>
            <button
              className="block w-full text-left text-blue-600 p-2"
              onClick={() => handleCallClick("+966510731221")}
            >
              اتصل الآن
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Layout;
